import { createElementBlock as o, openBlock as l, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return l(), o("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.445 5.992A6 6 0 0 0 8.94 9.595h3.7a1 1 0 0 1 0 2H8.455a6.1 6.1 0 0 0 .136 1.736h4.05a1 1 0 0 1 0 2H9.452A6 6 0 0 0 14.445 18c1.538 0 2.94-.577 4.002-1.529a1 1 0 0 1 1.334 1.49 8.005 8.005 0 0 1-12.614-2.63H5a1 1 0 1 1 0-2h1.552a8 8 0 0 1-.101-1.736H5a1 1 0 1 1 0-2h1.807a8.007 8.007 0 0 1 12.974-3.564 1 1 0 0 1-1.334 1.49 5.98 5.98 0 0 0-4.002-1.529",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_euro-Dij5LC24.js.map
